import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {EntityStoreUser} from 'constants/EntityStoreConstants';
import {Section, SECTIONS} from 'constants/NavConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

import NavBarIcon from './NavBarIcon';

export interface HomeIconProps {
  currentUser?: EntityStoreUser;
  icon: BenchlingIconName;
  isActive: boolean;
  onHomeIconClick: (section: Section, e: ElementMouseEvent) => void;
}

export default function HomeIcon(props: HomeIconProps): JSX.Element {
  let hasHomeActivity = false;

  // Set hasHomeActivity if user is signed in
  if (props.currentUser != null) {
    const {currentUserInboundRequests, pendingOrgInvites, userOrgsInboundRequests} = props.currentUser;
    hasHomeActivity = Boolean(
      (currentUserInboundRequests && currentUserInboundRequests.length > 0) ||
      (userOrgsInboundRequests && userOrgsInboundRequests.length > 0) ||
      (pendingOrgInvites && pendingOrgInvites > 0)
    );
  }

  return (
    <NavBarIcon
      className={css(styles.icon)}
      icon={props.icon}
      isActive={props.isActive}
      link="/"
      onSectionClick={props.onHomeIconClick}
      section={SECTIONS.HOME}
      hasActivity={hasHomeActivity}
    />
  );
}

const styles = StyleSheet.create({
  icon: {
    fontSize: 20,
    height: 20,
    width: 20,
  },
});
